export const commentItems = [
  {
    id: "cmt-1",
    name: "南岸风声",
    badge: "高频互动",
    avatar: "南",
    time: "09-10 09:32",
    content:
      "三版截图里第二版的聊天气泡顺序对不上，建议把首次出现时间也标在旁边，这样核对起来更直观。",
    likes: 342,
    replies: 28,
    tag: "截图证据",
  },
  {
    id: "cmt-2",
    name: "旧档案袋",
    badge: "",
    avatar: "旧",
    time: "09-10 08:58",
    content:
      "录音转写里 12:40 前后的两句话时间顺序好像调换了，听原文件确认一下会比较稳。",
    likes: 217,
    replies: 16,
    tag: "录音文件",
  },
  {
    id: "cmt-3",
    name: "路过核对",
    badge: "",
    avatar: "路",
    time: "09-10 08:15",
    content:
      "材料扫描件第 4 页的字段和表格版对不上，我把差异位置截图发在投稿里了，等核验结果。",
    likes: 164,
    replies: 11,
    tag: "文档材料",
  },
  {
    id: "cmt-4",
    name: "笔记未删",
    badge: "连续投稿",
    avatar: "笔",
    time: "09-09 23:47",
    content:
      "时间线整理得很清楚，尤其是三次节点的前后表述变化，希望继续保留旧版本方便追溯。",
    likes: 128,
    replies: 9,
    tag: "线索整理",
  },
];

export const hotTopics = [
  { id: "topic-1", name: "第二版截图时间戳", replies: 186 },
  { id: "topic-2", name: "录音 12:40 段落顺序", replies: 152 },
  { id: "topic-3", name: "第 4 页字段差异", replies: 121 },
  { id: "topic-4", name: "是否保留旧版本", replies: 88 },
  { id: "topic-5", name: "投稿核验标准", replies: 64 },
];